import defaultParsers from './default-parsers';
import { createParse, parseOrThrowWrapper } from './create-parse';
/**
 * parse without any locale, just numbers
 */
export var parse = createParse(defaultParsers);
export var parseOrThrow = parseOrThrowWrapper(parse);



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-date/esm/src/parse/parse.js
// module id = null
// module chunks = 